<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="用户权限管理" CMname="组织架构管理" ></HrrBreadcrumb>
		<HrrMainLayout>
			<template slot="searh">
				<el-row :gutter="24">
					<el-col :span="8" >
						<el-input placeholder="输入关键字查找节点" v-model="filterText" ></el-input>
					</el-col>
					<el-col :span="16" >
						
					</el-col>
				</el-row>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="false" >新增</el-button>
					<el-button type="primary" icon="fa fa-external-link" size="small" @click="Addchildclick">添加子节点</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" >编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" >删除</el-button>
					<el-button @click="resetChecked" type="primary" size="small" >取消所有选择</el-button>
					<el-button @click="RefreshTree" type="danger" size="small" >刷新树</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-row :gutter="24">
					<el-col :span="8" >
						<el-tree
						show-checkbox
						check-strictly
						check-on-click-node
						:data="treeData"
						:props="defaultProps"
						node-key="orgId"
						:default-expand-all="defaultexpandall"
						:filter-node-method="filterNode"
						ref="OrganizationTree"
						v-loading="loading">
					</el-tree>
				</el-col>
				<el-col :span="10" :offset="6" >
					<HrrDetailLayout v-show="isFormShow" >
						<template slot="head" >
							{{title}}
						</template>
						<template slot="Form" >
							<el-form status-icon :model="form" ref="form" :rules="rules" label-width="100px" >
								<el-form-item label="父节点：" v-if="form.parentName" >
									{{form.parentName}}
								</el-form-item>
								<el-form-item label="节点名称：" prop="orgName">
									<el-input v-model="form.orgName"></el-input>
								</el-form-item>
								<el-form-item label="节点描述：" prop="orgDesc">
									<el-input v-model="form.orgDesc" type="textarea" :rows="3" ></el-input>
								</el-form-item>
								<el-form-item label="所在地：" prop="orgType" v-if="form.levelType==30">
									<el-radio-group v-model="form.orgType">
										<el-radio v-for="item in OrgTypeData" :label="item.typeValue">{{item.typeName}}</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="组织类型：" prop="levelType" >
									<el-radio-group v-model="form.levelType">
										<el-radio-button v-for="item in LevelTypeData" :label="item.typeValue" :disabled="item.disabled">{{item.typeName}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</el-form>
						</template>
						<template slot="buttons" >
							<el-button type="primary" @click="submitOForm('form')">提 交</el-button>
							<el-button type="info"  @click="resetMForm('form')" v-if="false" >重 置</el-button>
							<el-button  @click="CloseForm" >关 闭</el-button>
						</template>
					</HrrDetailLayout>
				</el-col>
			</el-row>
		</template>
	</HrrMainLayout>
</div>
</template>
<script>
	export default{
		name: 'Organization_Tree',
		watch:{
			filterText(val) {
				this.$refs.OrganizationTree.filter(val);
			}
		},
		data(){
			return{
				defaultexpandall:false,
				filterText:"",
				title:"添加节点",
				ishasfather:false,
				treeData:[],
				defaultProps: {
					children: 'childList',
					label: 'orgName'
				},
				loading:true,
				form:{
					orgId:"",
					orgName:"",
					orgDesc:"",
					orgType:"0",
					parentId:"",
					parentName:"",
					levelType:10
				},
				rules:{
					orgName:[ { required: true, message: '请输入节点名称' , trigger: 'blur'}]
				},
				isFormShow:false,
				OrgTypeData:[],
				LevelTypeData:[],
				isAdd:false
			}
		},
		methods:{
			filterNode(value, data) {
				if (!value) return true;
				return data.orgName.indexOf(value) !== -1;
			},
			initData(){
				this.loading=true;
				var Vuethis=this;
				this.$hrraxios.get(this.$api.system.organizationTree)
				.then((response)=>{
					Vuethis.loading=false;
					var data=response.data;
					var gettype=Object.prototype.toString;
					if(data.success==true)
					{
						if(gettype.call(data.data)!="[object Array]"){

							Vuethis.treeData=[data.data];
						}else{
							Vuethis.treeData=data.data;
						}
					}else{
						Vuethis.$message.error(data.prompt);
					}
				})
				.catch((error)=>{

				})
			},
			initParamsData(){
				var myVuethis=this;
				var getType=(myparams,mydata,Vthis,callback)=>{
					this.$hrraxios.get(this.$api.base.gettypelist,{params:myparams})
					.then((response)=>{
						var data=response.data;
						if(data.success==true){
							myVuethis[mydata]=data.data;
							if(callback){
								callback();
							}
						}else{
							Vthis.$message.error("数据初始化失败,请联系管理员");
						}
					})
					.catch((error)=>{
						console.log(error);
					});
				};
				getType({typeFortable:"Hrr_organization",typeForfield:"Org_Type"},"OrgTypeData",myVuethis);
				getType({typeFortable:"Hrr_organization",typeForfield:"Level_Type"},"LevelTypeData",myVuethis,this.initdisabled);
			},
			initForm(){
				this.form.orgId="";
				this.form.orgName="";
				this.form.orgDesc="";
				this.form.orgType="0";
				this.form.parentId="";
				this.form.parentName="";
				this.form.levelType=10;
			},
			RefreshTree(){
				this.initData();
			},
			Addclick(){
				this.initForm();
				this.isFormShow=true;
				this.title="【添加新节点】";
				this.initdisabled(10);
				this.isAdd=true;
			},
			Addchildclick(){
				var selectnodes=this.$refs.OrganizationTree.getCheckedNodes();
				if(selectnodes.length<1){
					this.$message({message:"请先选择节点在操作",type:"warning"});
					return;
				}
				if(selectnodes.length>1)
				{
					this.$message({message:"只能操作一个节点",type:"warning"});
					return;
				}
				var sn=selectnodes[0];
				if(sn.levelType==40)
				{
					this.$alert("已经是部门，不能在添加子节点","提示");
					return;
				}
				this.initForm();
				this.isFormShow=true;
				this.title=sn.orgName+"【添加子节点】";
				this.form.parentId=sn.orgId;
				this.form.parentName=sn.orgName;
				this.form.levelType=sn.levelType+10;
				this.initdisabled(this.form.levelType);
				this.isAdd=true;
			},
			editclick(){
				var selectnodes=this.$refs.OrganizationTree.getCheckedNodes();
				if(selectnodes.length<1)
				{
					this.$message({message:"请先选择节点在删除",type:"warning"});
					return;
				}
				if(selectnodes.length>1)
				{
					this.$message({message:"只能操作一个节点",type:"warning"});
					return;
				}
				var sn=selectnodes[0];
				this.initForm();
				this.isFormShow=true;
				this.title=sn.orgName+"【编辑】";
				this.form.orgId=sn.orgId;
				this.form.orgName=sn.orgName;
				this.form.orgDesc=sn.orgDesc;
				this.form.orgType=sn.orgType;
				this.form.parentId=sn.parentId;
				this.form.levelType=sn.levelType;
				this.initdisabled(this.form.levelType);
				this.isAdd=false;
			},
			delclick(){
				var selectnodes=this.$refs.OrganizationTree.getCheckedNodes();
				if(selectnodes.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					selectnodes.forEach(nodes=>{
						var postRe=this.$hrraxios.post(this.$api.system.orgenizationDel,{organId:nodes.orgId});
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.success==false)
							{
								isalldel=false;
								Vuethis.$message({message:arguments[i].data.prompt,type:"error"});
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			initdisabled(val){
				this.LevelTypeData.forEach((n,i)=>{
					if(arguments.length>0){
						n.disabled=(n.typeValue==val)?false:true;
					}else{
						n.disabled=false;
					}
				});
			},
			submitOForm(formName){
				this.$refs[formName].validate((valid) =>{
					if (valid) {
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						var Vuethis=this;
						var apiUrl=(this.isAdd==true)?this.$api.system.orgenizationAdd:this.$api.system.orgenizationModify;
						this.$hrraxios.post(apiUrl,this.form)
						.then(function(response){
							loading.close();
							var data=response.data;
							if(data.success==true)
							{
								Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.initData();
									Vuethis.isFormShow=false;
								}});
							}else{
								Vuethis.$message({message:data.prompt,type:"error"});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					}
					else{
						return false;
					}
				});
			},
			CloseForm(){
				this.isFormShow=false;	
			},
			resetChecked() {
				this.$refs.OrganizationTree.setCheckedKeys([]);
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			}
		},
		created(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style>
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-right: 8px;
}
</style>
